/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IAuthState } from '../../models/Authorization/IAuthorization';
const initialState = {
  assignedPermissions: {},
  resourcePermissions: {}
} as IAuthState;
export const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'GET_AUTH_DETAILS':
      return {
        ...state,
        assignedPermissions: action.assignedPermissions
      };

    case 'GET_AUTH_POLICY_DETAILS':
        return {
          ...state,
          resourcePermissions: action.resourcePermissions
        };

    default:
      return state;
  }
};
